module.exports = __webpack_public_path__ + "img/1.e00ea864.png";